import React from "react";
import "./TicketReportModal.css";

const TicketReportModal = ({ isOpen, onClose, report }) => {
  if (!isOpen) return null;

  const { totalTickets, createdTickets = [], failedTickets = [], validRecords = [], badRecords = [] } = report;

  return (
    <div className="modal-overlay">
      <div className="modal-box">
        <h2 className="modal-title">Bulk Ticket Creation Report</h2>
        <p><strong>Valid Records:</strong> {validRecords.length} &nbsp;&nbsp;&nbsp; <strong>Bad Records:</strong> {badRecords.length}</p>
        <p><strong>Total Tickets Processed:</strong> {totalTickets}</p>
        <p><strong>Created Tickets:</strong> {createdTickets.length} &nbsp;&nbsp;&nbsp; <strong>Failed Tickets:</strong> {failedTickets.length}</p>
        <hr/>
        <div className="ticket-group">
          <section className="ticket-section">
            <h3>✅ Created Tickets</h3>
            {createdTickets.length > 0 ? (
              <ul>
                {createdTickets.map((ticket, idx) => (
                  <li key={idx}>
                    {ticket.ticket_id} — {ticket.asset_serial}: {ticket.message}
                  </li>
                ))}
              </ul>
            ) : (
              <p>No tickets were created.</p>
            )}
          </section>

          <section className="ticket-section">
            <h3>❌ Failed Tickets</h3>
            {failedTickets.length > 0 ? (
              <ul>
                {failedTickets.map((ticket, idx) => (
                  <li key={idx}>
                    {ticket.asset_serial || "Unknown Serial"}: {ticket.message}
                  </li>
                ))}
              </ul>
            ) : (
              <p>No tickets failed.</p>
            )}
          </section>
        </div>
        <p style={{textAlign:"center"}}>
          <br/>
          <strong>Need help?</strong>
          <br/>
          Please contact us at <a href="mailto:sales@techcyclesolutions.com">sales@techcyclesolutions.com</a> or call us at <a href="tel:913-717-7779">913-717-7779</a>
          <button className="close-button" onClick={onClose}>Close</button>
        </p>

      </div>

    </div>
  );
};

export default TicketReportModal;
